/* eslint-disable no-param-reassign */
import { FETCH_STATUSES } from '../../../utils/fetchStatusUtils';

export default function updateResourceSlice(options) {
  const { resource, repository } = options;

  return {
    initialState: {
      [resource]: {
        updatingStatus: FETCH_STATUSES.idle,
        errors: null,
      },
    },
    reducers: {
      updateResourceStart(state) {
        state[resource].updatingStatus = FETCH_STATUSES.pending;
        state[resource].errors = null;
      },
      updateResourceSuccess(state) {
        state[resource].updatingStatus = FETCH_STATUSES.fulfilled;
      },
      updateResourceFail(state, { payload: { errors } }) {
        state[resource].updatingStatus = FETCH_STATUSES.failed;
        state[resource].errors = errors;
      },
      updateResourceReset(state) {
        state[resource].updatingStatus = FETCH_STATUSES.idle;
        state[resource].errors = null;
      },
    },
    actionCreators(restDispatch) {
      return {
        updateResource: async (...params) => {
          try {
            restDispatch('updateResourceStart');
            const result = await repository.update(...params);
            const { data } = result;
            restDispatch('updateResourceSuccess', data);
          } catch (errors) {
            const { response } = errors;
            const { data } = response;
            restDispatch('updateResourceFail', data);
            throw errors;
          }
        },
        updateResetResource: () => restDispatch('updateResourceReset'),
      };
    },
    abstractSelector: (state) => {
      return {
        resource: state[resource],
      };
    },
  };
}
